

<div class="weekly-report-header">
  <div class="header-left">
    <h1>{{ 'compliance.weekly_report.weekly_status_report_title' | translate }}</h1>
  </div>
  <div class="header-right">
    <span class="profile-name">{{ currentUserName }}</span>
  </div>
</div>

<div class="container">
  <ejs-tab id="element" [selectedItem]="selectedTabIndex" (selected)="onTabSelected($event)">
    <e-tabitems>
      <e-tabitem class="tab">
        <ng-template #headerText>
          <div> {{ 'compliance.weekly_report.statutory' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <div class="tab-container">
            <div class="all-report-cards">
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('ComprehensiveReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.overall_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.overall_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('ComprehensiveReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('ComprehensiveReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('LocationReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.location_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.location_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('LocationReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('LocationReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('UserReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.user_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.user_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('UserReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('UserReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('CategoryReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.category_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.category_summary_desc' | translate }}
                    </p>
                  </div>
                    <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('CategoryReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('CategoryReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('RiskReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.risk_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.risk_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('RiskReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('RiskReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="downloadDetailReport()">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.detailed_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.detailed_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('DetailReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('DetailReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('CriticalRiskReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.critical_risk_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.critical_risk_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('CriticalRiskReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('CriticalRiskReport')">
                  </div>
                </div>
              </div>
              <div class="report-card" *ngIf="isDepartmentSummaryReportVisible">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('DepartmentReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.department_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.department_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDoc('DepartmentReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('DepartmentReport')">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </e-tabitem>

      <e-tabitem class="tab">
        <ng-template #headerText>
          <div>{{ 'compliance.weekly_report.internal' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <div class="tab-container">
            <div class="all-report-cards">
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('ComprehensiveReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.overall_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.overall_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('ComprehensiveReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('ComprehensiveReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('LocationReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.location_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.location_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('LocationReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('LocationReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('UserReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.user_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.user_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('UserReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('UserReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('CategoryReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.category_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.category_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('CategoryReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('CategoryReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('RiskReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.risk_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.risk_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('RiskReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('RiskReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="downloadDetailReport()">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.detailed_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.detailed_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('DetailedReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('DetailedReport')">
                  </div>
                </div>
              </div>
              <div class="report-card">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('CriticalRiskReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.critical_risk_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.critical_risk_summary_desc' | translate }}
                    </p>
                  </div>
                   <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('CriticalRiskReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('CriticalRiskReport')">
                  </div>
                </div>
              </div>
              <div class="report-card" *ngIf="isDepartmentSummaryReportVisible">
                <div class="card-header">
                  <img src="assets/vectors/overall-summary-report-card.svg" />
                  <!-- <button class="card-action-button" (click)="onClikOpenButton('DepartmentReport')">
                    <img src="assets/vectors/open-button.svg" alt="Open Button" />
                  </button> -->
                </div>
                <div class="card-inside">
                  <div class="card-body">
                    <h3>{{ 'compliance.weekly_report.department_summary_report' | translate }}</h3>
                    <p>
                      {{ 'compliance.weekly_report.department_summary_desc' | translate }}
                    </p>
                  </div>
                  <div class="card-actions">
                    <img class="action-icon" src="assets/vectors/view-only-eye.svg" [alt]="'compliance.weekly_report.view' | translate" [title]="'compliance.weekly_report.preview' | translate"
                      (click)="viewDocForInternal('DepartmentReport')">
                    <img class="action-icon" src="assets/vectors/download-small-icon.svg" [alt]="'compliance.weekly_report.download' | translate"
                      [title]="'compliance.weekly_report.download' | translate" (click)="downloadReport('DepartmentReport')">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </e-tabitem>
    </e-tabitems>
  </ejs-tab>
</div>

<!-- <div id="windowSummarypopup" stye="width:100%; height:800px;"></div>
<div id="windowInternalSummarypopup" stye="width:100%; height:800px;"></div>
<div id="windowCategorypopup" stye="width:100%; height:800px;"></div>
<div id="windowInternalCategorypopup" stye="width:100%; height:800px;"></div>
<div id="windowlocationpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternallocationpopup" stye="width:100%; height:800px;"></div>
<div id="windowuserpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternaluserpopup" stye="width:100%; height:800px;"></div>
<div id="windowriskpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternalriskpopup" stye="width:100%; height:800px;"></div>
<div id="windowdetailpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternaldetailpopup" stye="width:100%; height:800px;"></div>
<div id="windowcriticalriskpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternalcriticalriskpopup" stye="width:100%; height:800px;"></div>
<div id="windowDepartmentpopup" stye="width:100%; height:800px;"></div>
<div id="windowInternalDepartmentpopup" stye="width:100%; height:800px;"></div> -->


<app-view-temp-documents *ngIf="showViewTempDocuments" [fileID]="file_id" [docType]="doc_type"
  [customerIDForWeeklyReport]="decryptedCustomerId" [userIDForWeeklyReport]="decryptedUserId"
  [dataitemcustomer_id]="decryptedCustomerId" (close)="closeViewTempDocuments()">
</app-view-temp-documents>

<div *ngIf="alertData.alertMessage !== ''">
  <app-alert-popup class="display-none" [Data]="alertData" (close)="closeAlert()"
    (confirm)="confirmAlert($event)" [Width]="517" [Height]="200"></app-alert-popup>
</div>

<div class="tab-loader-overlay" *ngIf="hasDownloaded">
    <div class="custom-spinner"></div>
</div>